<template class="custom-template">
  <TecBanHeader/>
  <q-layout class="custom-layout">
    <q-card class="custom-card">
      <q-card-section>
        <p style="text-align: left; font-weight: bold;">Relatório de Ocorrências D3-Signus Abertas</p>
        <div class="row q-col-gutter-md">
          <q-input rounded standout="bg-grey text-white" v-model="filters.codPcIf" label="Código PC IF" class="col-3" />
          <q-input rounded standout="bg-grey text-white" v-model="filters.agencia" label="Agência" class="col-3" />
          <q-input rounded standout="bg-grey text-white" v-model="filters.tipoUsar" label="Tipo Usar" class="col-3" />
          <q-input rounded standout="bg-grey text-white" v-model="filters.classe" label="Classe" class="col-3 " />
          <q-input rounded standout="bg-grey text-white" v-model="filters.numeroOcorrencia" label="Número Ocor" class="col-3 " />
        </div>
      </q-card-section>
    </q-card>

    <q-card class="custom-card">
      <q-card-section>
        <q-page-container>
          <q-page>
            <h6>Resultado da Consulta <i style="color: green; cursor: pointer" title="Baixar relatório em Excel." v-show="this.data.length !== 0" class="fa-duotone fa-regular fa-file-excel" @click="exportarExcel"></i></h6>
            <p>{{StatusConsultaItau}}</p>
            <q-table
                :rows="filteredData"
                :columns="columns"
                row-key="id"
                class="my-sticky-header-table"
                rows-per-page-label="Ocorrências por página:"
                no-data-label="Nenhum dado disponível"
                loading-label="Carregando..."
                separator="cell"
                :pagination="{
                  page: 1,
                  rowsPerPage: 15
                }"
            />
          </q-page>
        </q-page-container>
      </q-card-section>
    </q-card>

  </q-layout>
</template>

<script>
import axios from "axios";
import * as XLSX from 'xlsx';

import TecBanHeader from '../../components/TecBanHeader.vue'

import { Notify } from 'quasar'

import {validToken} from '../../services/authentication.js';


export default {
  components: {
    TecBanHeader,
  },
  name: 'ListarOcorrencias',
  data() {
    return {
      filters: {
        dataInicio: '',
        dataFim: '',
        codPcIf: '',
        agencia: '',
        tipoUsar: '',
        classe: '',
        numeroOcorrencia: ''
      },
      columns: [
        {name: 'pcIf', label: 'PC IF', align: 'left', field: row => row.equipamento.numeroSerieGrbe},
        {name: 'classe', label: 'Classe', align: 'left', field: row => row.areaResponsavel.classeAtendimento},
        {name: 'statusOcor', label: 'Status Ocor', align: 'left', field: row => row.status},
        {name: 'numeroOcor', label: 'Número Ocor', align: 'left', field: row => row.numeroOcorrencia},
        {name: 'seqOcor', label: 'Seq Ocor', align: 'left', field: row => row.sequencia},
        {name: 'dataHoraAbertura', label: 'Data/hora de Abertura', align: 'left', field: row => this.formatarDataBR(row.dataAbertura)},
        {name: 'sintoma', label: 'Sintoma', align: 'left', field: row => row.sintoma.codigo},
        {name: 'descSintoma', label: 'Desc Sintoma', align: 'left', field: row => row.sintoma.descricao},
        {name: 'dataHoraFechamento', label: 'Data/hora de Fechamento', align: 'left', field: row => this.formatarDataBR(row.dataFechamento)},
        {
          name: 'dataHoraPrevisaoAtendimento',
          label: 'Data/hora de Previsão de Atendimento',
          align: 'left',
          field: row => this.formatarDataBR(row.dataPrevisaoAtendimento)
        },
        {name: 'tipoUsar', label: 'Tipo Usar', align: 'left', field: row => row.prioridade.codigo},
        {name: 'descTipoUsar', label: 'Desc Tipo Usar', align: 'left', field: row => row.prioridade.descricao},
        {name: 'textoLivre', label: 'Texto Livre', align: 'left', field: row => row.textoLivre},
        {name: 'contato', label: 'Contato', align: 'left', field: row => row.contato},
        {name: 'agencia', label: 'Agência', align: 'left', field: row => row.agencia.numeroAgencia},
        {name: 'postag', label: 'Postag', align: 'left', field: row => row.agencia.pontoAtendimento},
        {name: 'sequen1', label: 'Sequen1', align: 'left', field: row => row.agencia.sequencia},
        {name: 'tipoEquipamento', label: 'Tipo Equipamento', align: 'left', field: row => row.equipamento.tipo},
        {name: 'serieCompleta', label: 'Série completa', align: 'left', field: row => row.equipamento.numeroSerie},
        {name: 'codigoAreaResp', label: 'Código Area Resp', align: 'left', field: row => row.areaResponsavel.codigo},
        {name: 'descAreaResp', label: 'Desc Area Resp', align: 'left', field: row => row.areaResponsavel.descricao},
        {name: 'idOcor', label: 'ID Ocor', align: 'left', field: row => row.id},
      ],
      data: [],
      intervalId: null,
      StatusConsultaItau: null
    };
  },
  methods: {

    obterOcorrencias() {
      validToken();
      const token = localStorage.getItem('token');
      const token_type = localStorage.getItem('token_type');
      axios.get(process.env.VUE_APP_API_ITAU + process.env.VUE_APP_API_ITAU_GET_OCORRENCIAS, {
        headers: {
          'Authorization': `${token_type} ${token}`
        }
      })
          .then((response) => {
            this.data = response.data[0].motivoErro !== null ?  [] : response.data;
            if(response.data[0].motivoErro !== null){
              Notify.create({
                type: 'warning',
                position: 'center',
                message: 'Foi realizado a consulta no Itaú porém retornou erro, entre em contato com o time responsável através deste e-mail: _Grupo_SustentacaoATMManagerMG_Itau@tecban.com.br - Erro: ' + response.data[0].motivoErro + " - Data da consulta: " + this.formatarDataBR(response.data[0].dataHoraConsultaItau),
                timeout: 15000,
              });
              console.log(response.data[0])
              this.StatusConsultaItau = 'Foi realizado a consulta no Itaú porém retornou erro, entre em contato com o time responsável através deste e-mail: _Grupo_SustentacaoATMManagerMG_Itau@tecban.com.br -Erro: ' + response.data[0].motivoErro + " - Data da consulta: " + this.formatarDataBR(response.data[0].dataHoraConsultaItau);
            }else{
              Notify.create({
                type: 'positive',
                position: 'top-right',
                message: 'Consulta feita com sucesso!'
              });
              this.StatusConsultaItau = this.data.length === 0 ? "A consulta não retornou dados, assim que houver dados eles serão aparecer automáticamente." : "Consulta realizada no Itaú em: " + this.formatarDataBR(this.data[0].dataHoraConsultaItau);
            }
          })
          .catch((error) => {
            console.log(error);
            Notify.create({
              type: 'negative',
              message: 'Ocorreu um erro ao tentar consultar as ocorrencias, uma nova tentativa será feita no próximo minuto.',
              position: 'top-right'
            });
            this.data = [];
            this.StatusConsultaItau = "Erro ao tentar consultar, aguarde alguns instantes, novas consultas serão realizadas.";
          });
    },
    formatarDataBR(dataISO) {

      if(dataISO == null){
        return null
      }
      const data = new Date(dataISO);
      const dia = String(data.getDate()).padStart(2, '0');
      const mes = String(data.getMonth() + 1).padStart(2, '0');
      const ano = data.getFullYear();
      const horas = String(data.getHours()).padStart(2, '0');
      const minutos = String(data.getMinutes()).padStart(2, '0');
      const segundos = String(data.getSeconds()).padStart(2, '0');

      return `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`;
    },
    exportarExcel() {
      const dadosParaExportar = this.filteredData.length ? this.filteredData : this.data;
      const dadosFormatados = dadosParaExportar.map(row => {
        const formattedRow = {};
        this.columns.forEach(column => {
          formattedRow[column.label] = column.field(row);
        });
        return formattedRow;
      });
      const ws = XLSX.utils.json_to_sheet(dadosFormatados);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Ocorrências');
      XLSX.writeFile(wb, 'ocorrencias.xlsx');
    }
  },
  computed: {
    filteredData() {
      return this.data.filter(row => {
        const matchesCodPcIf = this.filters.codPcIf ? row.equipamento.numeroSerieGrbe.toUpperCase().includes(this.filters.codPcIf.toUpperCase()) : true;
        // const matchesDescAreaResp = this.filters.descAreaResp ? row.areaResponsavel.descricao.toUpperCase().includes(this.filters.descAreaResp.toUpperCase()) : true;
        const matchesTipoUsar = this.filters.tipoUsar ? row.prioridade.codigo.toUpperCase().includes(this.filters.tipoUsar.toUpperCase()) : true;
        const matchesClasse = this.filters.classe ? row.areaResponsavel.classeAtendimento.toUpperCase().includes(this.filters.classe.toUpperCase()) : true;
        const matchesNumeroOcor = this.filters.numeroOcorrencia ? row.numeroOcorrencia.toUpperCase().includes(this.filters.numeroOcorrencia.toUpperCase()) : true;
        const matchesAgencia = this.filters.agencia ? row.agencia.numeroAgencia.toUpperCase().includes(this.filters.agencia.toUpperCase()) : true;
        return matchesCodPcIf && matchesTipoUsar && matchesClasse && matchesNumeroOcor && matchesAgencia;
      });
    },
  },
  mounted() {
    this.obterOcorrencias();
    this.intervalId = setInterval(this.obterOcorrencias, 60000);
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
};
</script>

<style llang="sass">

thead tr:first-child th {
  background-color: rgb(213, 0, 0);
  color: white;
  font-weight: bold
}

.custom-card {
  padding: 20px; /* Espaçamento interno */
  border-radius: 10px; /* Bordas arredondadas */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Sombra */
  margin: 1.5%;
}

.custom-layout {
  margin-top: 2%;
}



</style>